import React from 'react';
import DataUploadWizard from '../../components/DataUploadWizard';

const DataUpload = () => (
  <div className="data-upload">
    <DataUploadWizard />
  </div>
);

export default DataUpload;
